<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="任务名称"
					>
					</el-table-column>
					<el-table-column
						prop="index"
						label="任务指标"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	import Api from '../../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				default: ''
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				tableData: []
			}
		},
		computed: {
			...mapState(['mission'])
		},
		methods: {
			/********************** @Function ************************/
			// 查询患者任务
			getUserTask() {
				const that = this;
				that.loading = true;
				let requestData = {
					missionId: '1,2,3,4,5,6,7,8,9,10,11,12,13,303,304',
					userPatientId: that.uid
				};
				Api.getUserTask(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						res.data.data.forEach(v => {
							that.mission.forEach((vv) => {
								vv.id == v.missionId
								&& list.push({
									name: vv.name,
									index: v.missionIndex
								});
							});
						});
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay (newValue) {
				this.$emit('changeDisplay', newValue);
				if (newValue) {
					this.getUserTask();
				} else {
					this.loading = false;
					this.tableData = [];
				}
			}
		}
	}
</script>

<style>
</style>
